export class HttpError extends Error {
    status;
    url;
    constructor(response, error) {
        super(`Request to ${response.url} returned ${response.status}`, error);
        this.name = 'HttpError';
        this.status = response.status;
        this.url = response.url;
    }
    getStatusCode() {
        return this.status;
    }
}
